import { dispatch } from 'rfx-core';

import Form from './_.extend';

class OTPForm extends Form {
  hooks = () => ({
    async onSuccess(form) {
      try {
        const response = await dispatch('auth.login', form.values());
        const message = 'Success, logging in...';
        dispatch('ui.snackBar.open', message);
        form.clear();
        return response;
      } catch (error) {
        form.invalidate(error.message);
        return {};
      }
    },
  });

  setup() {
    return {
      fields: ['otp'],
      labels: {
        otp: 'Verification Code',
      },
      placeholders: {
        otp: 'Enter the code you were sent here',
      },
      rules: {
        otp: 'required|string|between:5,50',
      },
    };
  }
}

export { OTPForm };
